import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/19940644-3eb0-4fdf-8f38-e4eb390ff1a3";
export const REGISTER_URL = "https://a.ntrk2.com/56915acf-e4d6-456d-b4e8-e3e0e49ee551";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://up555.kzw2a.com/download?openExternalBrowser=1&id=kkkoco6yzhjp17i";

export * from "./codes";
export * from "./context";
